import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import { toHtmlId } from "^/utils/toHtmlId";
import headlineWidgetIcon from "../../assets/images/headline_widget.svg";

Scrivito.provideEditingConfig("HeadlineWidget", {
  title: "Headline",
  thumbnail: headlineWidgetIcon,
  attributes: {
    ...localizeAttrList(
      ["level", "alignment", "showDividingLine", "showMargin"],
      "HeadlineWidget"
    ),
  },
  properties: [
    "style",
    "level",
    "alignment",
    "showDividingLine",
    "showMargin",
    "textColor",
    "anchor",
  ],
  initialContent: {
    alignment: "left",
    headline: "Lorem Ipsum",
    showDividingLine: "no",
    showMargin: "yes",
    style: "h2",
  },

  validations: [
    [
      "anchor",
      (anchor) => ({
        message: `used anchor is #${toHtmlId(
          anchor
        )}. Make sure it is unique on the page.`,
        severity: "info",
      }),
    ],
  ],
});
